import Logo from "@/components/logo"
import { Outlet } from "react-router-dom"
import { ActionsMenu } from "./actions-menu"
import Menu from "./menu"
import { MenuMobile } from "./menu-mobile"
import Fullscreen from "@/components/layout/fullscreen"
import UserInfo from "./user-info"

export default function AppFrame() {
  return (
    <Fullscreen>
      <div className="flex flex-row h-screen">
        <div className="flex-col justify-start w-4/12 border-r p-5 gap-5 hidden md:flex max-w-96">
          <Logo />
          <Menu />
        </div>
        <div className="flex flex-col w-full">
          <div className="flex flex-row justify-end p-4 border-b  shadow-sm md:shadow-none">
            <div className="flex md:invisible items-center flex-grow">
              <MenuMobile />
            </div>
            <div className="flex flex-row gap-3 items-center ">
              <UserInfo />
              <ActionsMenu />
            </div>
          </div>
          <div className="flex flex-col p-5 flex-shrink overflow-scroll flex-grow">
            <Outlet />
          </div>
        </div>
      </div>
    </Fullscreen>
  )
}
